// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__B7TD1"};